// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".github{position:fixed;top:0;right:0;cursor:pointer}.github:after{content:'';position:absolute;top:0;right:0;z-index:-1;border:35px solid transparent;border-top-color:#fff;border-right-color:#fff}.github a{cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
